import { useOnAir } from '../components/live/useOnAir';

// The sidebar's "N בשידור": how many sessions (plenum and committees) are on air now, not
// counting broadcasts on a break. From the live feed (meta/liveNow, re-read every 3 minutes
// here) merged with meta/scheduleNow; without a fresh feed, the sessions the time rule calls
// live, as before. 0 until the feed's first read, and when the reads fail (the badge is optional).
const REFRESH_MS = 3 * 60 * 1000;

export const useLiveSessionCount = (): number => {
  const { merged, ready } = useOnAir({ refreshMs: REFRESH_MS });
  return ready ? merged.liveCount : 0;
};
